<div class="dialog template-dialog">
  <button mat-button mat-dialog-close class="dialog__close" (click)="onClose()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'template.close' | translate }}</span>
  </button>
  <div mat-dialog-title>
    <h1>{{ 'template.selectTemplate' | translate }}</h1>
  </div>
  <div class="caption">{{ 'template.caption' | translate }}</div>
  <form>
    <div mat-dialog-content class="content">
      <div class="radio-button-block">
        <mat-radio-group name="selectedTemplateId" class="radio-group" [formControl]="templateFC">
          @for (template of templatesCatalog; track template) {
            <mat-radio-button
              class="radio-button"
              [value]="template.templateId"
              >
              {{ template.templateName }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <div class="image-block">
        <div class="image-border" miq-bg-image [imageSrc]="selectedTemplateImageSrc"></div>
      </div>
    </div>
    <div mat-dialog-actions class="mat-dialog-actions">
      <button class="btn-submit" (click)="selectTemplate()">{{ 'template.selectTemplate' | translate }}</button>
    </div>
  </form>
</div>
